// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2hLMY","description":"PatientConsentPreview_description__18EEn"};